import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class GroupByService {
    groupby(value: Array<any>, field: string): Array<any> {
        const groupedObj = value.reduce((prev, cur) => {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            } else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        return Object.keys(groupedObj).map(key => ({
            key,
            value: groupedObj[key]
        }));
    }
}
